import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
  modelBadge: {
    height: 21,
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1),
    borderRadius: "50px",
    backgroundColor: "#F0F0F0",
    color: "#636363",
    fontSize: "0.625rem",
  },
  modelIcon: {
    width: 15,
    height: 15,
    borderRadius: "50%",
    objectFit: "contain",
  },
  aspectRatioBadge: {
    height: 21,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1, 1.5),
    borderRadius: "50px",
    backgroundColor: "#F0F0F0",
    color: "#636363",
    fontSize: "0.625rem",

    "& span": {
      textWrap: "nowrap",
    },
  },
  aspectRatioContainer: {
    display: "grid",
    placeItems: "center",
    width: "15px",
    height: "15px",
  },
}));
